import { ChartLegendVariantType } from '../../../../../../components/chartLegend/types/chartLegend';
import { commonStyles } from '../commonStyles';
export const getHorizontalStyles = (FOUNDATIONS, FONT) => {
    return {
        [ChartLegendVariantType.HORIZONTAL]: {
            ...commonStyles(FOUNDATIONS, FONT),
            container: {
                ...commonStyles(FOUNDATIONS, FONT).container,
                flex_direction: 'row',
                gap: FOUNDATIONS.spacing_250,
                align_items: 'baseline',
            },
        },
    };
};
//# sourceMappingURL=horizontal.js.map